import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="app-bg-dark min-h-screen flex flex-col items-center justify-center px-4">
      <div className="text-center space-y-6">
        {/* 404 Text */}
        <div className="space-y-2">
          <h1 className="text-6xl md:text-8xl font-bold text-(--color-primary)">
            404
          </h1>
          <p className="text-2xl md:text-3xl font-semibold text-(--color-text-primary)">
            Page Not Found
          </p>
        </div>

        {/* Description */}
        <p className="text-(--color-text-muted) text-lg max-w-md">
          The page you're looking for doesn't exist. Let's get you back on
          track.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Link
            to="/home"
            className="inline-flex items-center gap-2 px-6 py-3 bg-(--color-primary) text-white dark:text-black rounded-lg hover:opacity-90 transition-opacity"
          >
            <Home className="h-5 w-5" />
            Go to Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 border border-(--color-primary) text-(--color-primary) rounded-lg hover:bg-(--color-primary)/10 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
